
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'loading',
})
export default class Loading extends Vue {
    @Prop({
        type: Boolean,
        default: true,
    })
    private layer!: boolean;

    @Prop({
        type: String,
        default: 'light',
    })
    private layerStyle!: string;

    @Prop({
        type: String,
        default: '#f5a400',
    })
    private color!: string;

    @Prop({
        type: String,
    })
    private customClass?: string;
}
